import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { ShortcutTypeGlobal } from '../../samwebDescription/samweb/shortcuts/shortcutTypeGlobal';
import { SettingsState, SettingsStateModel } from './settings.state';

export class SettingsSelectors {
   @Selector([SettingsState])
   public static getHotkeyTypeForShortcut(settings: SettingsStateModel) {
      return (shortCutCombo: string) => {
         if (_.isEmpty(shortCutCombo)) {
            return [];
         }

         return ShortcutTypeGlobal.values().filter((shortcutTyp) => {
            const configuredShortcut = settings.currentSettings.hotkeys[shortcutTyp.value];
            if (!_.isEmpty(configuredShortcut)) {
               return configuredShortcut === shortCutCombo;
            }
            return false;
         });
      };
   }

   @Selector([SettingsState])
   public static getHotkeyForAction(settings: SettingsStateModel): (actionName: string) => string {
      return (actionName: string) => {
         return settings.currentSettings.hotkeys[actionName] ?? ShortcutTypeGlobal[actionName].defaultHotkeyCombo;
      };
   }

   @Selector([SettingsSelectors.getHotkeyForAction])
   public static doActionsShareHotkeys(getHotkeyForAction) {
      return (actionOne: string, actionTwo: string) => {
         const shortcutComboOne = getHotkeyForAction(actionOne);
         const shortcutComboTwo = getHotkeyForAction(actionTwo);
         return shortcutComboOne === shortcutComboTwo;
      };
   }

   @Selector([SettingsSelectors.doActionsShareHotkeys])
   public static doDialAndAnswerShareHotkeys(doActionsShareHotkeys) {
      return doActionsShareHotkeys(ShortcutTypeGlobal.MAKE_CALL.value, ShortcutTypeGlobal.ACCEPT_CALL.value);
   }

   @Selector([SettingsState])
   public static areSettingsInitialized(settings: SettingsStateModel) {
      return settings.areSettingsInitialized;
   }
}
